'use client';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const Main404Text = styled(Typography)(() => ({
  color: '#FDFDFB',
  fontSize: '140px',
  fontType: 'bold',
  fontWeight: '500',
  lineHeight: '1',
  letterSpacing: '1.5px',
  textShadow:
    '68px 56px 35px rgba(64, 64, 32, 0.02), 38px 32px 30px rgba(64, 64, 32, 0.07), 17px 14px 22px rgba(64, 64, 32, 0.12), 4px 4px 12px rgba(64, 64, 32, 0.14), 0px 0px 0px rgba(64, 64, 32, 0.14)',
}));

export const MainBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const RedirectText = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: '500',
  marginBottom: theme.spacing(1),
  fontSize: '14px',
}));
